import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../../core/authentication/authentication.service';
import { UserService } from '../../core/user/user.service';
import { User } from '../../models/user';

@Component({
    selector: 'app-main-navigation',
    templateUrl: './main-navigation.component.html',
    styleUrls: ['./main-navigation.component.scss']
})
export class MainNavigationComponent implements OnInit {
    user: User;
    hiddenNav = false;
    public isPreview = this.authenticationService.isPreviewMode();

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private userService: UserService
    ) {}

    ngOnInit(): void {
        this.getUser();
    }

    signOut() {
        this.authenticationService.logout();
        this.router.navigate(['/auth']);
    }

    getUser() {
        this.userService
            .getUser()
            .pipe(first())
            .subscribe({
                next: resp => {
                    this.user = resp;
                },
                error: error => {}
            });
    }
}
